import React from 'react';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Services from './components/Services';
import Work from './components/Work';
import Cert from './components/Cert';
import Techstacks from './components/Techstacks';
import Projects from './components/Projects';
import Footer from './components/Footer';

const App = () => {
  React.useEffect(() => {
    // Set document title
    document.title = 'Jessile Bonzo - Web Developer';
    
    // Helper function to set meta tag content
    const setMetaTag = (selector, attribute, value) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        if (selector.includes('name=')) {
          element.setAttribute('name', selector.split('"')[1]);
        } else if (selector.includes('property=')) {
          element.setAttribute('property', selector.split('"')[1]);
        }
        document.head.appendChild(element);
      }
      element.setAttribute(attribute, value);
    };
    
    // Set meta tags
    setMetaTag('meta[name="description"]', 'content', 'Crafting intuitive and visually appealing websites with seamless user experiences and innovative, functional solutions.');
    setMetaTag('meta[property="og:title"]', 'content', 'Jessile Bonzo - Web Developer');
    setMetaTag('meta[property="og:description"]', 'content', 'Building modern, responsive, and accessible websites.');
    setMetaTag('meta[property="og:image"]', 'content', '/assets/JBD.png');

    // Change favicon
    const changeFavicon = (faviconURL: string) => {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'icon');
        document.head.appendChild(link);
      }
      (link as HTMLLinkElement).href = faviconURL;
    };    changeFavicon('/assets/Jb.png');
  }, []);

  return (
    <ThemeProvider>
      <div className="App font-montserrat">
        <Navbar />
        <Home />
        <Services />
        <Techstacks />
        <Work />
        <Cert />
        <Projects /> 
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default App;
